import { ImageComponent, toPlaceholderImage } from '@frontend/internal-assets';
import type { ImageAssetProps } from '@frontend/internal-assets';
import optimizedImage from './image-assets/call-intel-patient-insight-promo.webp';

const thumbHashString = 'OQiCCoIeWfXIaX3KDNWpYFhXeXeAlwc=';
const placeholderImage = toPlaceholderImage(thumbHashString);

const calculatedAspectRatio = 2.388059701492537;
const originalWidth = 320;

const CallIntelPatientInsightPromo = ({
  aspectRatio = calculatedAspectRatio,
  width = originalWidth,
  ...rest
}: ImageAssetProps) => (
  <ImageComponent
    aspectRatio={aspectRatio}
    width={width}
    src={optimizedImage}
    placeholderSrc={placeholderImage}
    {...rest}
  />
);

export default CallIntelPatientInsightPromo;
